import { render, staticRenderFns } from "./DefaultReplacements.vue?vue&type=template&id=35ffe806"
import script from "./DefaultReplacements.vue?vue&type=script&lang=js"
export * from "./DefaultReplacements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports